module.exports = __webpack_public_path__ + "img/product_50.c6b015b.webp";